import React from "react";

const Icon = ({ name }) => {
  if (name === "plus") {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M16 9.33331V22.6666" stroke="currentColor" />
        <path d="M9.33325 16H22.6666" stroke="currentColor" />
        <rect
          x="0.5"
          y="0.5"
          width="31"
          height="31"
          rx="1.5"
          stroke="currentColor"
        />
      </svg>
    );
  } else if (name === "close") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14">
        <g
          fill="none"
          fillRule="evenodd"
          stroke="currentColor"
          transform="translate(1 1)">
          <line x1="11.667" y2="11.667" />
          <line x2="11.666" y2="11.667" />
        </g>
      </svg>
    );
  } else if (name === "search") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14">
        <defs>
          <polygon id="a" points="0 0 12.984 0 12.984 12.985 0 12.985" />
          <polygon id="c" points="0 0 3.349 0 3.349 3.343 0 3.343" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            fill="#405363"
            d="M6.49255,1 C3.46388,1 0.99988,3.46334 0.99988,6.492 C0.99988,9.52069 3.46388,11.98469 6.49255,11.98469 C9.52059,11.98469 11.98459,9.52069 11.98459,6.492 C11.98459,3.46334 9.52059,1 6.49255,1 Z M6.49255,12.98469 C2.91255,12.98469 -0.00012,10.07199 -0.00012,6.492 C-0.00012,2.912 2.91255,0 6.49255,0 C10.07259,0 12.98459,2.912 12.98459,6.492 C12.98459,10.07199 10.07259,12.98469 6.49255,12.98469 Z"
            mask="url(#b)"
          />
          <g transform="translate(10.16 10.471)">
            <mask id="d" fill="#fff">
              <use xlinkHref="#c" />
            </mask>
            <path
              fill="#405363"
              d="M2.8495,3.3432 C2.7222,3.3432 2.5942,3.2945 2.4962,3.1972 L0.1468,0.8545 C-0.0485,0.6592 -0.0492,0.3425 0.1462,0.1472 C0.3408,-0.0495 0.6575,-0.0481 0.8535,0.1459 L3.2028,2.4892 C3.3982,2.6845 3.3988,3.0005 3.2035,3.1959 C3.1062,3.2945 2.9775,3.3432 2.8495,3.3432 Z"
              mask="url(#d)"
            />
          </g>
        </g>
      </svg>
    );
  } else if (name === "arrow-up") {
    return(
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="11"
        viewBox="0 0 10 11">
        <g fill="#405363">
          <path d="M4.51624951,11.0001539 C4.26311951,11.0001539 4.05391951,10.8120539 4.02080951,10.5679539 L4.01624951,10.5001539 L4.01624951,0.500123912 C4.01624951,0.223983912 4.24010951,0.000123911544 4.51624951,0.000123911544 C4.76937951,0.000123911544 4.97857951,0.188233912 5.01167951,0.432283912 L5.01624951,0.500123912 L5.01624951,10.5001539 C5.01624951,10.7762539 4.79238951,11.0001539 4.51624951,11.0001539 Z" />
          <path d="M0.854309506,4.88612391 C0.659469506,5.08180391 0.342889506,5.08248391 0.147209506,4.88764391 C-0.0306804944,4.71051391 -0.0474204944,4.43277391 0.0973895056,4.23672391 L0.145689506,4.18054391 L4.16168951,0.147203912 C4.33933951,-0.0312160885 4.61808951,-0.0474460885 4.81412951,0.0985239115 L4.87028951,0.147173912 L8.88690951,4.18051391 C9.08180951,4.37617391 9.08110951,4.69275391 8.88550951,4.88761391 C8.70760951,5.06475391 8.42980951,5.08032391 8.23440951,4.93468391 L8.17840951,4.88615391 L4.51579951,1.20879391 L0.854309506,4.88612391 Z" />
        </g>
      </svg>
    );
    
  }

  return false;
};

export default Icon;
